/* eslint-disable max-classes-per-file */
import _ from "lodash";
import { Cellstyle, NumericCellChangeArg } from "~app/common/components/hot-doc/hotdoc/cell";
import { NumberUtils } from "~app/common/utils/number-utils";
import { HotCellNumericWithZero } from "~app/features/produktion/produktionsmal/produktionsmal-matris/celltypes";

type Callback = (newValue: NumericCellChangeArg) => void;
const LOCALE = "sv-SE";

const format = (value: number, formatOptions?: Intl.NumberFormatOptions) => {
    if(!NumberUtils.isNumeric(value)) {
        return "";
    }
    return value.toLocaleString(LOCALE, formatOptions);
};

export class VKNumericHotCell extends HotCellNumericWithZero {
    private readonly cellClassList: string[];
    private readonly formatOptions?: Intl.NumberFormatOptions;
    private readonly validateFn?: (value: any) => boolean;

    constructor(value: number, cellClassList: string[], extraflags: Cellstyle,
        onChange?: Callback,
        formatOptions?: Intl.NumberFormatOptions,
        validateFn?: (value: any) => boolean) {
        super(value, extraflags, onChange, false);
        this.cellClassList = cellClassList;
        this.formatOptions = formatOptions;
        this.validateFn = validateFn;
    }

    applyCustomStyles(td: HTMLTableCellElement) {
        if (this.cellClassList) {
            td.classList.add(...this.cellClassList);
        }
    }

    validate(value: any): boolean {
        if(_.isNil(value)) {
            return false;
        }

        value = value.toLocaleString(LOCALE).replace(/,/g, ".");

        if (this.validateFn !== undefined) {
            return this.validateFn(value);
        }

        if (_.isNaN(value)) {
            return false;
        }

        const decimal = Number.parseFloat(value);

        return (Number.isInteger(decimal) && decimal >= 0);
    }

    protected genHtml(): string {
        return format(this.value, this.formatOptions);
    }

    protected applyStyle(td: HTMLTableCellElement, cellProperties: any) {
        this.applyCustomStyles(td);
        super.applyStyle(td, cellProperties);
    }
}

export class VKLeveransplanNumericHotCell extends VKNumericHotCell {
    onDelete(): void {
        if (this.isReadonly) {
            return;
        }
        this.value = null;
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        const changeArg = this.changeArgumentFactory(this.value, () => { }, null);
        this.onChange(changeArg);
    }

    validate(value: any): boolean {
        if (value === "") {
            return true;
        }
        return super.validate(value);
    }
}
